'use strict';

angular.module('ClinicApp').factory('SpecialtyService', function(SpecialtyResource, AppointmentTypeResource) {
  return {
    listSpecialties: function() {
      return SpecialtyResource.query().$promise;
    },

    getSpecialtyAppointmentTypes: function(specialtyId) {
      return AppointmentTypeResource.query({
        specialty: specialtyId,
      }).$promise;
    },
  };
});
